<template>
    <form @submit.prevent="search" @reset.prevent="reset" class="filter">
        <b-row class="align-items-end">
            <b-col md="6" lg="4" xl="2" class="mb-3">
                <label>{{$t('NAME')}}</label>
                <b-input v-model="filter.name" type="text"></b-input>
            </b-col>

            <b-col class="mb-3">
                <app-button-submit :inline="true" :loading="loading" variant="primary" button_type="search">
                    {{$t("SEARCH") }}
                </app-button-submit>
                <app-button-reset :disabled="loading" :inline="true"  class="pl-2 ml-2" ></app-button-reset>
            </b-col>
        </b-row>
    </form>
</template>

<script>
    import AppButtonSubmit from "@/components/app/AppButton/AppButtonSubmit";
    import AppButtonReset from "@/components/app/AppButton/AppButtonReset";

    export default {
        name: "VatSetupFilter",
        components: {AppButtonReset, AppButtonSubmit},
        props: {
            loading: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                filter: {
                    page: 1
                }
            }
        },
        methods: {
            search() {
                this.$emit('search', this.filter)
            },
            reset() {
                this.filter = {page: 1}
                this.search()
            }
        }
    }
</script>

<style scoped>

</style>
